import NetworkUtil from "./NetworkUtil";
import {Service} from "../types/Service";
import {ServerResponse} from "../types/ServerResponse";

export default class ServicesAPI {
    public static async getAllServicesForApptForm():Promise<{success:boolean, reason:string, data?:Service[]}>{
        return NetworkUtil.makeGet("/api/admin/services/getAllServicesForApptForm");
    }

    public static async getAllServices():Promise<{success:boolean, reason:string, data?:Service[]}>{
        return NetworkUtil.makeGet("/api/admin/services");
    }

    public static async getAllDTCServices():Promise<{success:boolean, reason:string, data?:Service[]}>{
        return NetworkUtil.makeGet("/api/admin/services/dtc");
    }

    public static async getAllServicesForMachineExport():Promise<{success:boolean, reason:string, data?:Service[]}>{
        return NetworkUtil.makeGet("/api/admin/services/servicesForMachineExport");
    }
    public static async getAllServicesForFakeSampleGenerator():Promise<{success:boolean, reason:string, data?:Service[]}>{
        return NetworkUtil.makeGet("/api/admin/services/servicesForFakeSampleGenerator");
    }

    public static async getServicesForAppointmentForm():Promise<{label:string,value:number}[]>{
        return NetworkUtil.makeGet("/api/system/services");
    }

    public static async getServicesForWalkinForm():Promise<{success:boolean, reason:string, data?:Service[]}>{
        return NetworkUtil.makeGet("/api/system/servicesForWalkinForm");
    }

    public static async getServicesForSubmissionForm():Promise<{success:boolean, reason:string, data?:Service[]}>{
        return NetworkUtil.makeGet("/api/admin/servicesForSubmissionForm");
    }

    

    public static async getServiceNames():Promise<{success:boolean, reason:string, data?:{label:string,value:string}[]}>{
        return NetworkUtil.makeGet("/api/admin/services/names")
    }

    public static async getServiceLabels():Promise<{success:boolean, reason:string, data?:{label:string,value:number}[]}>{
        return NetworkUtil.makeGet("/api/admin/services/labels")
    }

    public static async filterServices(filter:{filter:{Name?,IsEnabled?,ShowInsurance?,IsLabService?,IsDTC?,PhysicianReviewRequired?}}):Promise<{success:boolean, reason:string, data?:Service[]}>{
        return NetworkUtil.makePost("/api/admin/services/filter", filter)
    }

    public static async createService(service:Service):Promise<ServerResponse>{
        return NetworkUtil.makePost("/api/admin/services/create", service)
    }

    public static async editService(service):Promise<ServerResponse>{
        return NetworkUtil.makePost("/api/admin/services/edit", service)
    }

    public static async getRenderers():Promise<{success:boolean, reason?:string, renderers?:{name:string, displayName:string, description:string}[]}>{
        return NetworkUtil.makeGet("/api/admin/services/renderers")
    }

}